var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn",class:`${_vm.btnType} ${_vm.btnLight} ${_vm.btnOutline} ${_vm.btnActive} ${_vm.btnActiveLight} ${_vm.btnDisabled}`,attrs:{"href":"javascript:void(0)"},on:{"click":_vm.click}},[(_vm.icon)?_c('i',{staticClass:"fas fs-4 me-2",class:_vm.icon}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }